import { render } from "./PhilosophyButton.vue?vue&type=template&id=2144af94&scoped=true"
import script from "./PhilosophyButton.vue?vue&type=script&lang=js"
export * from "./PhilosophyButton.vue?vue&type=script&lang=js"

import "./PhilosophyButton.vue?vue&type=style&index=0&id=2144af94&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-2144af94"

export default script